<app-breadcrumb-mkt [title]="title" [routeBase]="route"/>


<div class="table-responsive" xmlns="http://www.w3.org/1999/html" xmlns="http://www.w3.org/1999/html">
  <div class="d-flex justify-content-end  ">
    <button (click)="cleanId()" class="btn  btn-outline-secondary ms-2" data-bs-toggle="modal" data-bs-target="#addEspecialidad"><i
      class="bi bi-plus-circle"></i> Agregar
    </button>
  </div>
  <table class="table">
    <thead>
    <tr>
      <th scope="col">#</th>
      <th class="w-45" scope="col">Nombre Especialidad</th>
      <th scope="col">Categoría</th>
      <th scope="col">Descripción</th>
      <th scope="col">Icono</th>
      <th scope="col">Imagen</th>
      <th scope="col">ShowNavBar</th>
      <th scope="col">Acciones</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let item of especialidades; let i = index">
      <th scope="row">{{ i + 1 }}</th>
      <td>{{ item.especialidad }}</td>
      <td>{{ item.categoria }}</td>
      <td style="max-width: 200px;" class="text-truncate">{{ item.descripcion }}</td>
      <td>
        <img style="width: 100px" src="{{imgUrl}}{{ item.icono }}" alt="imgEspecialidad">
      </td>
      <td>
        <img style="width: 100px" src="{{imgUrl}}{{ item.imagen }}" alt="imgEspecialidad">
      </td>
      <td>{{ item.showNavBar }}</td>
      <td>
        <button class="btn btn-outline-secondary" (click)="getDataById(item._id)" data-bs-toggle="modal"
                data-bs-target="#editEspecialidad"><i class="bi bi-pencil-square"></i>
        </button>
        <button class="btn btn-outline-secondary" (click)="deleteByID(item._id)" ><i class="bi bi-trash"></i>
        </button>
      </td>
    </tr>
    </tbody>
  </table>
</div>

<div #addEspecialidad class="modal fade" id="addEspecialidad" tabindex="-1" aria-labelledby="addEspecialidad"
     aria-hidden="true">
  <div class="modal-dialog modal-xl modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="titleAdd">Agregar Especialidad</h1>
        <button (click)="resetdataAdd()" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="col-md-7 col-lg-12">
          <form class="needs-validation" [formGroup]="formAddEspecialidad" novalidate (ngSubmit)="onSubmit()">
            <div class="row g-3">
              <div class="col-sm-12">
                <label for="especialidadAdd" class="form-label">Nombre de la Especialidad</label>
                <input [value]="especialidad" formControlName="especialidad" type="text" class="form-control"
                       id="especialidadAdd" placeholder="Ingrese el nombre de la especialidad"
                       required/>
                <div style="color:red;" *ngIf="formAddEspecialidad.get('especialidad')?.errors?.['required']">El nombre
                  de la especialidad es obligatorio
                </div>

              </div>

              <div class="col-sm-12">
                <label for="descripcionAdd" class="form-label">Descripción</label>
                <textarea [value]="descripcion" formControlName="descripcion" type="text" class="form-control"
                          id="descripcionAdd" placeholder="Ingrese la descripción de la especialidad"></textarea>

                <div style="color:red;" *ngIf="formAddEspecialidad.get('descripcion')?.errors?.['required']">La
                  descripción es obligatoria
                </div>

              </div>


              <div class="col-sm-6">
                <label for="categoriaAdd" class="form-label">Categoría Promoción</label>
                <input [value]="categoria" formControlName="categoria" type="text" class="form-control"
                       id="categoriaAdd"
                       placeholder="Ingrese la categoría de la especialidad"
                       required>
                <div style="color:red;" *ngIf="formAddEspecialidad.get('categoria')?.errors?.['required']">La categoría
                  es obligatoria
                </div>

              </div>


              <div class="col-sm-6">
                <label for="showNavBarAdd" class="form-label">Visibilidad NavBar</label>
                <select class="form-control" formControlName="showNavBar" name="showNavBar" id="showNavBarAdd">
                  <option selected value="" disabled>Escoge...</option>

                  <option [value]="true">Visible</option>
                  <option [value]="false">No Visible</option>
                </select>
                <div style="color:red;" *ngIf="formAddEspecialidad.get('showNavBar')?.errors?.['required']">El
                  showNavBar Es obligatorio
                </div>

              </div>

              <div class="col-sm-12">
                <label for="procedimientosList" class="form-label">La lista de procedimientos que contiene la especialidad  <span class="text-secondary">-- Para el correcto muestreo de la información separar cada item por un salto de línea (enter).</span></label>
                <textarea class="form-control" formControlName="procedimientosList" id="procedimientosList"></textarea>
                  <div style="color:red;" *ngIf="formAddEspecialidad.get('procedimientosList')?.errors?.['required']">La lista de procedimientos es obligatoría. </div>
              </div>


              <hr class="my-4">

              <h4 class="mb-3">Multimedia</h4>
              <div class="col-sm-6">
                <div class="my-3">
                  <div class="form-check">
                    <label class="form-check-label" for="files">Imagen <span class="text-body-secondary">(Se recomienda imagen en formato 4x4 para mejorar su visibilidad y en formato .png)</span></label>
                    <input #inputImagen type="file" id="files" class="form-control" (change)="capturarArchivo1($event)"
                           accept="image/*">
                  </div>
                  <div class="input-group image" *ngIf="previewImagen">
                    <img width="100%" [src]="previewImagen" alt="">
                  </div>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="my-3">
                  <div class="form-check">
                    <label class="form-check-label" for="icon">Ícono <span class="text-body-secondary">(Se recomienda imagen en formato 512px X 512px para mejorar su visibilidad y en formato .png)</span></label>
                    <input #inputIcon type="file" id="icon" class="form-control" (change)="capturarArchivo2($event)" accept="image/*">
                  </div>
                  <div class="input-group image" *ngIf="previewIcon">
                    <img class="mx-auto" width="50%" [src]="previewIcon" alt="">
                  </div>
                </div>
              </div>



              <hr class="my-4">
              <div class="col-sm-12 ">
              <span class="text-secondary">Sucursales Disponibles</span>
              <div class=" text-center px-1 justify-content-center py-6">
                <ng-container *ngFor="let sucursal of sucursales">
                <span *ngIf="!isSucursalAssigned(sucursal)"
                      class="badge fs-6  align-items-center p-2 pe-2 text-primary-emphasis bg-primary-subtle border border-primary-subtle rounded-pill">
                    <i class="rounded-circle fs-5 me-1 bi bi-geo"></i> {{ sucursal.nameSucursal }}
                  <span class="vr mx-2"></span>
                      <a (click)="addSucursal(sucursal)" style="cursor: pointer"><i class="bi bi-plus-circle"></i></a>
                  </span>
                </ng-container>
              </div>
              </div>
              <hr class="my-4">
              <span class="text-secondary">Sucursales Asignadas </span>
              <div class=" text-center mx-1 justify-content-center py-6">
                <span *ngFor="let sucursal of centrosMedicos.controls; let i = index"
                      class="badge fs-6  align-items-center p-2 pe-2 text-primary-emphasis bg-primary-subtle border border-primary-subtle rounded-pill">
                    <i class="rounded-circle fs-5 me-1 bi bi-geo"></i> {{ sucursal.get('nameSucursal')?.value }}
                  <span class="vr mx-2"></span>
                  <a (click)="removeSucursal(i)" style="cursor: pointer"><i class="bi bi-dash-circle"></i></a>
                  </span>
              </div>

              <hr class="my-4">
              <!--              <a (click)=centrosMedicos style="cursor: pointer"><i class="bi bi-plus-circle"></i></a>-->


              <div class="container">
                <button class="w-100 btn btn-primary btn-lg" type="submit" (click)="sendAllData()"
                        [disabled]="isLoading">
                  <span class="text" *ngIf="!isLoading">Crear Especialidad</span>
                  <div *ngIf="isLoading" class="spinner-border text-light " role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
<div #editEspecialidades class="modal fade" id="editEspecialidad" tabindex="-1" aria-labelledby="editEspecialidad"
     aria-hidden="true">
  <div class="modal-dialog modal-xl modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="edit">Editar Especialidad</h1>
        <button (click)="resetdataEdit()" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="col-md-7 col-lg-12">
          <form class="needs-validation" [formGroup]="formEditEspecialidad" novalidate (ngSubmit)="onSubmit()">
            <div class="row g-3">
              <div class="col-sm-12">
                <label for="especialidad" class="form-label">Nombre de la Especialidad</label>
                <input [value]="especialidad" formControlName="especialidad" type="text" class="form-control"
                       id="especialidad" placeholder="Ingrese el nombre de la especialidad"
                       required/>
                <div style="color:red;" *ngIf="formEditEspecialidad.get('especialidad')?.errors?.['required']">El nombre
                  de la especialidad es obligatorio
                </div>

              </div>

              <div class="col-sm-12">
                <label for="descripcion" class="form-label">Descripción</label>
                <textarea [value]="descripcion" formControlName="descripcion" type="text" class="form-control"
                          id="descripcion" placeholder="Ingrese la descripción de la especialidad"></textarea>

                <div style="color:red;" *ngIf="formEditEspecialidad.get('descripcion')?.errors?.['required']">La
                  decripción es obligatoria
                </div>

              </div>


              <div class="col-sm-6">
                <label for="categoria" class="form-label">Categoría Promoción</label>
                <input [value]="categoria" formControlName="categoria" type="text" class="form-control" id="categoria"
                       placeholder="Ingrese la categoría de la especialidad"
                       required>
                <div style="color:red;" *ngIf="formEditEspecialidad.get('categoria')?.errors?.['required']">La categoría
                  es obligatoria
                </div>

              </div>


              <div class="col-sm-6">
                <label for="showNavBar" class="form-label">Visibilidad NavBar</label>
                <select class="form-control" formControlName="showNavBar" name="showNavBar" id="showNavBar">
                  <option selected value="" disabled>Escoge...</option>

                  <option [value]="true">Visible</option>
                  <option [value]="false">No Visible</option>
                </select>
                <div style="color:red;" *ngIf="formEditEspecialidad.get('showNavBar')?.errors?.['required']">El
                  showNavBar Es obligatorio
                </div>

              </div>


              <div class="col-sm-12">
                <label for="procedimientosListEdit" class="form-label">La lista de procedimientos que contiene la especialidad  <span class="text-secondary">-- Para el correcto muestreo de la información separar cada item por un salto de línea (enter).</span></label>
                <textarea class="form-control" formControlName="procedimientosList" id="procedimientosListEdit"></textarea>
                <div style="color:red;" *ngIf="formEditEspecialidad.get('procedimientosList')?.errors?.['required']">La lista de procedimientos es obligatoría. </div>
              </div>


              <hr class="my-4">

              <h4 class="mb-3">Multimedia</h4>

              <div class="col-sm-6">
                <div class="my-3">
                  <div class="form-check">
                    <label class="form-check-label" for="filesEdit">Imagen <span class="text-body-secondary">(Se recomienda imagen en formato 4x4 para mejorar su visibilidad y en formato .png)</span></label>
                    <input #editInputImagen type="file" id="filesEdit" class="form-control" (change)="capturarArchivo1($event)"
                           accept="image/*">
                  </div>
                  <div class="input-group image" *ngIf="previewImagen">
                    <img width="100%" [src]="previewImagen" alt="">
                  </div>
                  <div class="input-group image" *ngIf="!previewImagen && imgPreview">
                    <img width="100%" [src]="imgUrl + imgPreview" alt="">
                  </div>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="my-3">
                  <div class="form-check">
                    <label class="form-check-label" for="iconEdit">Ícono <span class="text-body-secondary">(Se recomienda imagen en formato 512px X 512px para mejorar su visibilidad y en formato .png)</span></label>
                    <input #editInputIcon type="file" id="iconEdit" class="form-control" (change)="capturarArchivo2($event)"
                           accept="image/*">
                  </div>
                  <div class="input-group image" *ngIf="previewIcon">
                    <img class="mx-auto" width="50%" [src]="previewIcon" alt="">
                  </div>
                  <div class="input-group image" *ngIf="!previewIcon && iconPreview">
                    <img class="mx-auto" width="50%" [src]="imgUrl + iconPreview" alt="">
                  </div>
                </div>
              </div>

              <hr class="my-4">
              <div class="col-sm-12 ">
                <span class="text-secondary">Sucursales Disponibles</span>
                <div class=" text-center px-1 justify-content-center py-6">
                  <ng-container *ngFor="let sucursal of sucursales">
                <span *ngIf="!isSucursalAssigned(sucursal)"
                      class="badge fs-6  align-items-center p-2 pe-2 text-primary-emphasis bg-primary-subtle border border-primary-subtle rounded-pill">
                    <i class="rounded-circle fs-5 me-1 bi bi-geo"></i> {{ sucursal.nameSucursal }}
                  <span class="vr mx-2"></span>
                      <a (click)="addSucursal(sucursal)" style="cursor: pointer"><i class="bi bi-plus-circle"></i></a>
                  </span>
                  </ng-container>
                </div>
              </div>
              <hr class="my-4">

              <span class="text-secondary">Sucursales Asignadas </span>
              <div class=" text-center mx-1 justify-content-center py-6">
                <span *ngFor="let sucursal of centrosMedicos.controls; let i = index"
                      class="badge fs-6  align-items-center p-2 pe-2 text-primary-emphasis bg-primary-subtle border border-primary-subtle rounded-pill">
                    <i class="rounded-circle fs-5 me-1 bi bi-geo"></i> {{ sucursal.get('nameSucursal')?.value }}
                  <span class="vr mx-2"></span>
                  <a (click)="removeSucursal(i)" style="cursor: pointer"><i class="bi bi-dash-circle"></i></a>
                  </span>
              </div>
              <hr class="my-4">

              <div class="row gy-3"></div>

              <hr class="my-4">
              <div class="container">
                <button class="w-100 btn btn-primary btn-lg" type="submit"
                        (click)="updateEspecialidadWeb(_idEspecialidad)" [disabled]="isLoading">
                  <span class="text" *ngIf="!isLoading">Actualizar Especialidad</span>
                  <div *ngIf="isLoading" class="spinner-border text-light " role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>

    </div>
  </div>
</div>


<app-notifications/>
